export default {
  close: 'Закрыть',
  dataIterator: {
    noResultsText: 'Не найдено подходящих записей',
    loadingText: 'Запись загружается...',
  },
  dataTable: {
    itemsPerPageText: 'Строк на странице:',
    ariaLabel: {
      sortDescending: ': Упорядочено по нисходящей. Активируйте, чтобы убрать сортировку.',
      sortAscending: ': Упорядочено во восходящей. Активируйте для упорядочивания по ниcходящей.',
      sortNone: ': Не упорядочено. Активируйте для упорядочивания по восходящей.',
    },
    sortBy: 'Сортировать по',
  },
  dataFooter: {
    pageText: '{0}-{1} of {2}',
    itemsPerPageText: 'Записей на странице:',
    itemsPerPageAll: 'Все',
    nextPage: 'Следующая страница',
    prevPage: 'Предыдущая страница',
    firstPage: 'Первая страница',
    lastPage: 'Последняя страница',
  },
  datePicker: {
    itemsSelected: '{0} выбран',
  },
  noDataText: 'Отсутствуют данные',
  carousel: {
    prev: 'Предыдущий визуальный',
    next: 'Следующий визуальный',
  },
  calendar: {
    moreEvents: 'Еще {0}',
  },
  fileInput: {
    counter: 'Файлов: {0}',
    counterSize: 'Файлов: {0} (всего {1})',
  },
  utilities: 'Утилиты',
  checkTemplateProxy: {
    title: 'Проверка ответа template proxy',
    response: 'Ответ от template proxy',
    fields: {
      method: 'Метод запроса',
      path: 'Путь для прокси',
      message: 'Параметр "message"',
      subscriber: 'Параметр "subscriber"',
      address: 'Параметр "address"',
      protocol: 'Параметр "protocol"',
    },
  },
  hasMNOBans: 'Есть баны MNO',
  blockInternational: 'Блокировать международный трафик',
  mainMenu: 'Главное меню',
  dashboard: 'Дашборд',
  profile: 'Профиль',
  changePassword: 'Сменить Пароль',
  admin: 'Админ',
  users: 'Пользователи',
  contract: 'Договор',
  contracts: 'Договоры',
  services: 'Сервисы',
  senders: 'Отправители',
  templates: 'Шаблоны',
  logout: 'Выйти',
  collapse: 'Скрыть',
  localeChange: 'English',
  login: 'Логин',
  password: 'Пароль',
  forgotPassword: 'Забыли пароль?',
  authorize: 'Войти',
  incorrectAuth: 'Некорректный логин или пароль',
  deleteUsersConfirmation: 'Вы уверены, что хотите удалить выбранных пользователей?',
  name: 'Имя',
  email: 'Email',
  fullName: 'Полное имя',
  title: 'Название',
  isActive: 'Активен',
  isPermanent: 'Перманент',
  bannedAt: 'Забанен',
  numberOfBans: '# Банов',
  userIsActive: 'Пользователь активен',
  templateIsActive: 'Шаблон активен',
  userIsSuperuser: 'Пользователь админ',
  isSuperuser: 'Админ',
  actions: 'Действия',
  manageUsers: 'Управления Пользователями',
  createUser: 'Создать Пользователя',
  add: 'Добавить',
  create: 'Создать',
  addMask: 'Добавить маску',
  addMNO: 'Добавить оператора',
  checkMNOMask: 'Проверить маску оператора',
  checkMask: 'Проверить маску',
  addMNOMask: 'Добавить маску оператора',
  originalMNOName: 'Ориганальное наименование оператора',
  masks: 'Маски',
  MNOMasks: 'Маски операторов',
  mask: 'Маска',
  MNO: 'Оператор',
  originalName: 'Ориганальное Название',
  maskOrPhone: 'Маска или Телефон',
  deleteMNOMaskConfirm: 'Вы уверены, что хотите удалит данную маску оператора?',
  edit: 'Редактировать',
  editProfile: 'Редактировать Профиль',
  delete: 'Удалить',
  welcome: 'Добро пожаловать',
  passBadMessages: 'Пропускать плохие сообщения',
  currentlyPassBadMessages: 'пропускать',
  currentlyNotPassBadMessages: 'не пропускать',
  currentlyIgnoreUserBans: 'игнорировать',
  currentlyNotIgnoreUserBans: 'не игнорировать',
  currentlyActive: 'активен',
  currentlyNotActive: 'неактивен',
  currentlySuperuser: 'админ',
  currentlyNotSuperuser: 'не админ',
  setPassword: 'Пароль',
  confirmPassword: 'Подтвердите Пароль',
  cancel: 'Отмена',
  reset: 'Сброс',
  save: 'Сохранить',
  submit: 'Отправить',
  editUser: 'Редактировать Пользователя',
  user: 'Пользователь',
  proxyHost: 'Хост для прокси',
  proxyReportHost: 'Хост для прокси отчетов',
  deleteServicesConfirmation: 'Вы уверены, что хотите удалить выбранные сервисы?',
  manageServices: 'Управление Сервисами',
  createService: 'Создать Сервис',
  editService: 'Редактировать Сервис',
  deleteSendersConfirmation: 'Вы уверены, что хотите удалить выбранных отравителей?',
  deleteMNOSendersConfirmation: 'Вы уверены, что хотите удалить выбранных отравителей для Оператора?',
  manageSenders: 'Управление Отправителями',
  createSender: 'Создать Отправителя',
  editSender: 'Редактировать Отправителя',
  editTemplate: 'Редактировать Шаблон',
  createTemplate: 'Создать Шаблон',
  proxyCallBackUrl: 'Колбек для прокси',
  phone: 'Номер телефона',
  proxyError: 'Ошибка прокси',
  proxyErrors: 'Ошибки Прокси',
  createProxyUserBan: 'Забанить пользователя',
  manageProxyErrors: 'Управление Ошибками Прокси',
  proxyUserBans: 'Баны пользователей',
  ignoreUserBans: 'Игнорировать баны',
  editProxyError: 'Редактировать ошибку прокси',
  createProxyError: 'Создать ошибку прокси',
  statusCode: 'Код статуса',
  response: 'Ответ',
  errorCode: 'Код ошибки',
  description: 'Описание',
  userBanDuration: 'Длительность бана',
  service: 'Сервис',
  template: 'Шаблон',
  sender: 'Отправитель',
  checkTemplate: 'Проверить шаблон',
  message: 'Сообщение',
  parseMessage: 'Спарсить сообщение',
  bans: 'Баны',
  list: 'Список',
  management: 'Управление',
  statistics: 'Статистика',
  manageProxyUserBans: 'Управление Банами',
  activeCheckbox: 'Активные',
  notActiveCheckbox: 'Неактивные',
  activate: 'Активировать',
  deactivate: 'Деактивировать',
  priority: 'Приоритет',
  editPriority: 'Редактировать приоритет',
  managePriorities: 'Управление приоритетами',
  priorities: 'Приоритеты',
  ratePerSecond: 'Лимит в секунду',
  manageMNOs: 'Управления операторами',
  mnos: 'Операторы',
  mno: 'Оператор',
  type: 'Тип',
  conn: 'Подключение',
  editMNO: 'Редактировать оператора',
  mnoSenders: 'Отправители оператора',
  tag: 'Тег',
  tags: 'Теги',
  mnoBans: 'Баны операторов',
  gateway: 'Шлюз',
  commentary: 'Комментарий',
  banPolicies: 'Политики Банов',
  banMultiplier: 'Множитель Банов',
  maxBans: 'Максимум Банов',
  permanentBanDuration: 'Длительность Перманентного Бана',
  repeatedBan: 'Банить Повторно',
  moUnban: 'Разбан при МО трафике',
  mtUnban: 'Разбан при МТ трафике',
  updateBanPolicy: 'Обновить Политику Банов',
  createBanPolicy: 'Создать Политику Банов',
};
